import { render, staticRenderFns } from "./newAction.vue?vue&type=template&id=090d3c48&scoped=true"
import script from "./newAction.vue?vue&type=script&lang=js"
export * from "./newAction.vue?vue&type=script&lang=js"
import style0 from "./newAction.vue?vue&type=style&index=0&id=090d3c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d3c48",
  null
  
)

export default component.exports